import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Content = styled.div`
  padding: 40px 50px;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 25px 20px 20px;
  }
`;

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 20px;
  }
`;

export const Title = styled(Typography.Header)`
  margin-bottom: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

export const Description = styled(Typography.Body)`
  margin-bottom: 30px;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.secondary.labels};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 15px;
    margin-bottom: 20px;
  }
`;

export const ActionsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;
